import { render, staticRenderFns } from "./yesHistogram.vue?vue&type=template&id=084a9531&scoped=true"
import script from "./yesHistogram.vue?vue&type=script&lang=js"
export * from "./yesHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a9531",
  null
  
)

export default component.exports